import * as THREE from 'three';

export const toSRGB = (hex: string) =>
  new THREE.Color(hex).convertLinearToSRGB();
